import { Component, Injector, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { ApiService } from 'src/app/Services/api.service';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { Geo } from 'src/app/util/geo';
import { v4 as uuidv4 } from 'uuid';
import { ParkinglotselectorComponent } from 'src/app/features/parking/parking/parkinglots/modals/parkinglotselector/parkinglotselector.component';
import { AddcontrolledareaterminalComponent } from './addcontrolledareaterminal/addcontrolledareaterminal.component';
import { EditcontrolledareaaccessmethodComponent } from './editcontrolledareaaccessmethod/editcontrolledareaaccessmethod.component';
import { EditcontrolledareabarrierComponent } from './editcontrolledareabarrier/editcontrolledareabarrier.component';
import { EditcontrolledareatrafficlightComponent } from './editcontrolledareatrafficlight/editcontrolledareatrafficlight.component';
import { EditcontrolledareacameraComponent } from './editcontrolledareacamera/editcontrolledareacamera.component';
import { EditcontrolledareadisplayComponent } from './editcontrolledareadisplay/editcontrolledareadisplay.component';
import { EditcontrolledareagateComponent } from './editcontrolledareagate/editcontrolledareagate.component';
import { EditcontrolledarealaneComponent } from './editcontrolledarealane/editcontrolledarealane.component';
import { EditcontrolledareapaymentterminalComponent } from './editcontrolledareapaymentterminal/editcontrolledareapaymentterminal.component';
import { EditcontrolledareaterminalComponent } from './editcontrolledareaterminal/editcontrolledareaterminal.component';
import { EditcontrolledareacellrouterComponent } from './editcontrolledareacellrouter/editcontrolledareacellrouter.component';
import { EditcontrolledareauserinputComponent } from './editcontrolledareauserinputdevice/editcontrolledareauserinput/editcontrolledareauserinput.component';
import { ParkingLotLinkDirection } from '@models/enums/parking-lot-link-direction.enum';
import { SpaceAllocationModalComponent } from './space-allocation-modal/space-allocation-modal.component';

@Component({
    selector: 'app-editcontrolledarea',
    templateUrl: './editcontrolledarea.component.html',
    styleUrls: ['./editcontrolledarea.component.scss'],
    standalone: false
})
export class EditcontrolledareaComponent extends ModelEditor {

  public MapTarget: any | null = null;
  public MapTargetMode: string = "polygon";
  public HighlightTarget: any = {};
  public GateBackgroundPolygons: any[] = []; //backgruond items for device edit map 
  public GateBackgroundMarkers: any[] = []; //backgruond items for device edit map for currently selected gate
  public AreaBackgroundPolygons: any[] = []; //background items for main area edit map
  public AreaBackgroundMarkers: any[] = []; //background icons for main area edit map
  
  constructor(private modalService: SimpleModalService, private apiService: ApiServiceBase, private organizationsService: OrganizationsService, private injector: Injector, private fb: FormBuilder) {
    super("infrastructure/controlledareas", injector);
  }
  public override DefaultModel() {
    return { Name: "New Area", SessionExitTimeMinutes: 10, Controllers: [], AccessMethods: [], ParkingLots: [], Gates: [] }
  }
  public override AfterModelLoaded(): void {
    this.Form.markAsPristine();
    this.ProcessParkingLotLinks();
  }
  public override BeforeSave(): boolean | void {

  }

  public override FormLabels(): any {
    return {
      Name: 'Area Name',
      SessionExitTimeMinutes: 'Session Grace Period'
    }
  }

  public override Validators(): any {
    return {
      "Name": [Validators.required, Validators.minLength(2)],
      "SessionExitTimeMinutes": [Validators.required],
      "AccessMethods.RateSetId": [Validators.required],
      "AccessMethods.ClassName": [Validators.required]
    };
  }


  public GetAccessMethodText(className: string) {
    switch (className) {
      case "ControlledAreaAccessMethodPublic":
        return "Public";
      case "ControlledAreaAccessMethodWhiteList":
        return "Access List Only"
    }
    return "";
  }

  public GetAccessListDescription(control: AbstractControl): string {

    if (control.get('ClassName')?.value === "ControlledAreaAccessMethodPublic") {
      return "Public Access";
    } else {
      return control.get('PlateAccessListName')?.value;
    }
  }

  public MoveUp(index: number) {
    this.MoveAccessMethodSequence(index);

  }

  public MoveDown(index: number) {
    this.MoveAccessMethodSequence(index + 1);
  }

  // always move up
  private MoveAccessMethodSequence(index: number) {
    let accessMethods = this.FormArray(this.Form, 'AccessMethods').controls;
    if (index <= 0) {
      // this is the top element, return
      return;
    }
    if (index >= accessMethods.length) {
      // try to move the last one down
      return;
    }

    let am = accessMethods[index];
    accessMethods.splice(index, 1);
    accessMethods.splice(index - 1, 0, am);
    accessMethods.forEach((element, index) => {
      element.get('Sequence')?.setValue(index);
    });
  }

  public AddGate() {
    this.organizationsService.GetOrganizationDefaultPolygon().then(x => {
      let g = { Id: "", Name: "New Gate", 
      Lanes: [], PolygonPoints: x};
      this.organizationsService.GetOrganizationDefaultPolygon().then(x => g.PolygonPoints = x)
      this.EditGate(this.AddToFormArray(this.Form.get("Gates") as UntypedFormArray, g, "Gates"));
    })
  }
  public EditGate(fg: any) {
    this.modalService.addModal(EditcontrolledareagateComponent, { Form: fg })
      .subscribe((result) => {
        this.RefreshAreaBackgroundItems();
      });
  }
  public RemoveGate(index: number) {
    this.FormArray(this.Form, "Gates").removeAt(index);
  }

  public AddLane(gate: any) {
    let l = { Id: '', Name: "New Lane", WorkflowId: null, LocalControllerId: null, PolygonPoints: Geo.NewInnerPolygon(gate.get('GeoPolygonPoints').value, 0.0005), Cameras: [], Barriers: [], Displays: [], TrafficLights: [], PaymentTerminals: [], AllowedDirections:null };
    this.EditLane(this.AddToFormArray(gate.get('Lanes') as UntypedFormArray, l, "Gates.Lanes"), gate);
  }
  public EditLane(lane: any, gate: any) {
    let editingLane = lane;
    let allControllers = this.FormArray(this.Form, "Controllers").controls;
    this.modalService.addModal(EditcontrolledarealaneComponent, { Form: lane, Gate: gate, Controllers: allControllers })
      .subscribe((result) => {
        if (result != null) {
        }
      });
  }
  public RemoveLane(gate: AbstractControl, index: number) {
    this.FormArray(gate, "Lanes").removeAt(index);
  }

  public EditCellRouter(cellRouter: any){
    this.modalService.addModal(EditcontrolledareacellrouterComponent, {Form: cellRouter})
    .subscribe(result =>{
      this.RefreshAreaBackgroundItems();
    })
  }

  public AddCellRouter(lane: any){
    let c = { Id: uuidv4(), ClassName: "CellRouter", DeviceStatus:"New", Name:"New Cell Router", SerialNumber:"",Imei:"",Sim1Id:"", Sim2Id:"" };
    let fg = this.AddToFormArray(lane.get('CellRouters') as UntypedFormArray, c, "Gates.Lanes.CellRouters");

    this.EditCellRouter(fg);
  }

  public RemoveCellRouter(lane: AbstractControl, index: number){
    this.RemoveFromFormArray(lane.get('CellRouters') as UntypedFormArray, index);
  }

  public AddCamera(gate: any, lane: any) {
    let c = { Id: uuidv4(), Type: "dahua", LocalAddress: "192.168.1.110", LocalPort: 80, LocationPoints: Geo.PolygonCenterAsNumbers(lane.get('GeoPolygonPoints').value), ClassName: 'Camera', DeviceStatus: 'New', ActiveDirection: null, Username: null, Password: null, SerialNumber: null };
    let fg = this.AddToFormArray(lane.get('Cameras') as UntypedFormArray, c, "Gates.Lanes.Cameras");
    this.SetMapTarget(fg, lane, gate);
    this.EditCamera(fg);
  }
  public EditCamera(camera: any) {
    this.modalService.addModal(EditcontrolledareacameraComponent, { Form: camera })
      .subscribe((result) => {
        this.RefreshAreaBackgroundItems();
      });
  }
  public RemoveCamera(lane: AbstractControl, index: number) {
    this.RemoveFromFormArray(lane.get('Cameras') as UntypedFormArray, index);
  }

  public AddBarrier(lane: any) {
    let b = { Id: "", Type: "mo24", LocalAddress: "192.168.1.200", LocalPort: 80, LocationPoints: Geo.PolygonCenterAsNumbers(lane.get('GeoPolygonPoints').value), ClassName: 'Barrier', DeviceStatus: 'New', ActiveDirection: null, SerialNumber: null };
    this.EditBarrier(this.AddToFormArray(lane.get('Barriers') as UntypedFormArray, b, "Gates.Lanes.Barriers"))
  }
  public EditBarrier(barrier: any) {
    let editingBarrier = barrier;
    this.modalService.addModal(EditcontrolledareabarrierComponent, { Form: barrier })
      .subscribe((result) => {
        if (result != null) {
          this.RefreshAreaBackgroundItems();
        }
      });
  }
  public RemoveBarrier(lane: AbstractControl, index: number) {
    this.RemoveFromFormArray(lane.get('Barriers') as UntypedFormArray, index);
  }

  public AddTrafficLight(lane: any) {
    let t = {Id: "", 
      Type:"k3sign", 
      LocalAddress:"192.168.1.222", 
      LocalPort: 5200, 
      LocationPoints: Geo.PolygonCenterAsNumbers(lane.get('GeoPolygonPoints').value), 
      ClassName: 'TrafficLight', 
      DeviceStatus: 'New',
      Name: "Traffic Light",
      ActiveDirection: 'Both',
      SerialNumber: null,
      IsInverted: false,
      Brightness: 100,
      WorkflowDriven: false,
      ShowGreenFor: 'Both'
    };
    this.EditTrafficLight(this.AddToFormArray(lane.get('TrafficLights') as UntypedFormArray, t, "Gates.Lanes.TrafficLights"));
  }

  public EditTrafficLight(light: any) {
    let editingLight = light;
    this.modalService.addModal(EditcontrolledareatrafficlightComponent, { Form: light})
      .subscribe((result) => {
        if (result != null) {
          this.RefreshAreaBackgroundItems();
        }
      });
  }

  public RemoveTrafficLight(lane: AbstractControl, index: number) {
    this.RemoveFromFormArray(lane.get('TrafficLights') as UntypedFormArray, index);
  }

  public AddPaymentTerminal(lane: any) {
    let p = { Id: uuidv4(), LocalAddress: "127.0.0.1", LocalPort: 2008, ProviderType: "windcave", SerialNumber: null, ActiveDirection: null };
    this.EditPaymentTerminal(this.AddToFormArray(lane.get('PaymentTerminals') as UntypedFormArray, p, "Gates.Lanes.PaymentTerminals"))
  }
  public EditPaymentTerminal(terminal: any) {
    this.modalService.addModal(EditcontrolledareapaymentterminalComponent, { Form: terminal })
      .subscribe((result) => {
        if (result != null) {
        }
      });
  }
  
  public RemovePaymentTerminal(lane: AbstractControl, index: number) {
    this.RemoveFromFormArray(lane.get('PaymentTerminals') as UntypedFormArray, index);
  }

  public AddDisplay(lane: any) {
    let d = { Id: "", Type: "frogserver", LocalAddress: "127.0.0.1", LocalPort: 10165, SerialNumber: null, ActiveDirection: null };
    this.EditDisplay(this.AddToFormArray(lane.get('Displays') as UntypedFormArray, d, "Gates.Lanes.Displays"))
  }
  public EditDisplay(display: any) {
    let editingDisplay = display;
    this.modalService.addModal(EditcontrolledareadisplayComponent, { Form: display })
      .subscribe((result) => {
        if (result != null) {
        }
      });
  }
  public RemoveDisplay(lane: AbstractControl, index: number) {
    this.RemoveFromFormArray(lane.get('Displays') as UntypedFormArray, index);

  }

  public AddController(lane: any) {
    let targetLane = lane;
    this.modalService.addModal(AddcontrolledareaterminalComponent, { ExistingControllers: this.Form.get('Controllers'), Gates: this.Form.get('Gates'), Lane: lane })
      .subscribe((result) => {
        if (result != null) {
          if (result instanceof UntypedFormGroup) {
            //an existing controller was selected
            lane.get('LocalControllerId').setValue(result.get('Id')?.value);
          }
          else {
            lane.get('LocalControllerId').setValue(result.Id);
            this.AddToFormArray(this.Form.get('Controllers') as UntypedFormArray, result, "Controllers");
            this.RefreshAreaBackgroundItems();
          }
        }
      });
  }
  public EditController(id: any) {
    let allControllers = this.FormArray(this.Form, "Controllers").controls;
    let fg = allControllers.filter((x: any) => x.get('Id').value == id)[0];
    this.modalService.addModal(EditcontrolledareaterminalComponent, { Form: fg })
      .subscribe((result) => {
        if (result != null) {
          this.RefreshAreaBackgroundItems();
        }
      });
  }
  public RemoveController(lane: AbstractControl) {
    lane.get('LocalControllerId')?.setValue(null);
  }

  public GetController(id: string): any {
    let allControllers = this.FormArray(this.Form, "Controllers").controls;
    let fg = allControllers.filter((x: any) => x.get('Id').value == id);
    if (fg.length > 0)
      return fg[0];
    return null;
  }
  public GetControllerName(id: string): string {
    let controller = this.GetController(id);
    if (controller != null) {
      return controller.get("Name").value;
    }
    return "[Controller Not Found]";
  }

  public AddParkingLot() {
    this.modalService.addModal(ParkinglotselectorComponent, {})
      .subscribe((result) => {
        if (result != null) {
          this.apiService.Get("infrastructure/controlledareas/parkinglots/" + result.Id).then((lot: any) => {
            if (this.CheckFormArrayContains(this.FormArray(this.Form, "ParkingLots"), 'Id', lot.Id) == false) {
              this.AddToFormArray(this.FormArray(this.Form, "ParkingLots"), lot, "ParkingLots")
              this.RefreshAreaBackgroundItems();
            }
          })
        }
      });
  }

  public GetParkingLotById(id: string): AbstractControl | null {
    return this.FormArray(this.Form, 'ParkingLots').controls.find(x => x.get('Id')?.value === id) || null;
  }

  public AddParkingLotLink(sourceLotId: string, targetLotId: string) {
    const sourceLot = this.GetParkingLotById(sourceLotId);
    const targetLot = this.GetParkingLotById(targetLotId);
    
    if (sourceLot && targetLot) {
      const link = {
        SourceParkingLotId: sourceLotId,
        TargetParkingLotId: targetLotId,
        IsAllocationAdjustable: false,
        SourceAllocatedSpaces: 0,
        TargetAllocatedSpaces: 0
      };
      this.AddToFormArray(this.Form.get('ParkingLotLinks') as UntypedFormArray, link, 'ParkingLotLinks');
    }
  }

  public RemoveParkingLotLink(index: number) {
    this.FormArray(this.Form, "ParkingLotLinks").removeAt(index);
  }

  public UpdateParkingLotLinkAllocation(link: any, sourceAllocated: number, targetAllocated: number) {
    link.get('SourceAllocatedSpaces').setValue(sourceAllocated);
    link.get('TargetAllocatedSpaces').setValue(targetAllocated);
  }

  public GetLinkedParkingLots(parkingLot: any): any[] {
    const links = this.FormArray(this.Form, "ParkingLotLinks").controls;
    const lotId = parkingLot.get('Id')?.value;
    if (!lotId) return [];

    // Get unique linked lots by using a Set
    const linkedLotIds = new Set<string>();
    const linkedLots: any[] = [];

    links.forEach(link => {
      const sourceId = link.get('SourceParkingLotId')?.value;
      const targetId = link.get('TargetParkingLotId')?.value;
      
      if (sourceId === lotId && !linkedLotIds.has(targetId)) {
        linkedLotIds.add(targetId);
        const targetLot = this.FormArray(this.Form, "ParkingLots").controls.find(lot => lot.get('Id')?.value === targetId);
        if (targetLot) {
          linkedLots.push(targetLot);
        }
      }
    });

    return linkedLots;
  }

  public GetLinkPosition(parkingLot: any, linkedLot: any): { rowSpan: number, isFirst: boolean } {
    const parkingLots = this.FormArray(this.Form, "ParkingLots").controls;
    const lotIndex = parkingLots.findIndex(lot => lot.get('Id')?.value === parkingLot.get('Id')?.value);
    const linkedLotIndex = parkingLots.findIndex(lot => lot.get('Id')?.value === linkedLot.get('Id')?.value);
    
    if (lotIndex === -1 || linkedLotIndex === -1) {
      return { rowSpan: 1, isFirst: false };
    }

    const isFirst = lotIndex < linkedLotIndex;
    const rowSpan = Math.abs(linkedLotIndex - lotIndex) + 1;
    
    return { rowSpan, isFirst };
  }

  public GetLink(sourceLot: any, targetLot: any): any {
    if (!sourceLot || !targetLot) return null;
    
    const sourceId = sourceLot.get('Id')?.value;
    const targetId = targetLot.get('Id')?.value;
    
    if (!sourceId || !targetId) return null;

    return this.FormArray(this.Form, "ParkingLotLinks").controls.find(link => 
      (link.get('SourceParkingLotId')?.value === sourceId && link.get('TargetParkingLotId')?.value === targetId) ||
      (link.get('SourceParkingLotId')?.value === targetId && link.get('TargetParkingLotId')?.value === sourceId)
    );
  }

  public GetParkingLotName(id: string): string {
    if (!id) return '';
    const lot = this.FormArray(this.Form, "ParkingLots").controls.find(x => x.get('Id')?.value === id);
    return lot?.get('Name')?.value || '';
  }

  public RemoveParkingLot(index: number) {
    //this.Model.ParkingLots.splice(index, 1);
    this.FormArray(this.Form, "ParkingLots").removeAt(index);
    this.RefreshAreaBackgroundItems();
    this.Form.markAsDirty();
  }

  public AddAccessMethod() {
    let p = { ClassName: "ControlledAreaAccessMethodPublic", RateSetId: null, RateSetName: '', Sequence: this.FormArray(this.Form, 'AccessMethods').controls.length, AccessMethodDescription: 'Public Access', ChargeStrategyDescription: '' };
    let index = this.FormArray(this.Form, "AccessMethods").controls.length;
    let control = this.AddToFormArray(this.FormArray(this.Form, "AccessMethods"), p, "AccessMethods");
    
    this.EditAccessMethod(control)
      .subscribe((result) => {
        if (!result) {
          // If canceled, remove the access method
          this.FormArray(this.Form, "AccessMethods").removeAt(index);
        }
      });
  }
  public EditAccessMethod(model: any) {
    const parkingLotsArray = this.Form.get('ParkingLots') as UntypedFormArray;
    const parkingLots = parkingLotsArray.controls.map(control => ({
      Id: control.get('Id')?.value,
      Name: control.get('Name')?.value
    }));

    return this.modalService.addModal(EditcontrolledareaaccessmethodComponent, { 
      Form: model, 
      ParkingLots: parkingLots 
    });
  }
  public RemoveAccessMethod(index: number) {
    this.FormArray(this.Form, "AccessMethods").removeAt(index);
    this.Form.markAsDirty();
  }

  public SetMapTarget(device: any, lane: any, gate: any) {
    this.GateBackgroundPolygons = [];
    if (device != null) {
      //a perhipheral was clicked
      this.MapTarget = device.get('LocationPoints');
      this.MapTargetMode = "marker";
      this.HighlightTarget = device;
      this.RefreshGateBackgroundItems(gate, device);
    }
    else if (lane != null) {
      //a lane was clicked
      this.MapTarget = lane.get('GeoPolygonPoints');
      this.MapTargetMode = "polygon";
      this.HighlightTarget = lane;
      this.RefreshGateBackgroundItems(gate, lane);
    }
    else if (gate != null) {
      //a gate was clicked
      this.HighlightTarget = gate;
      this.MapTarget = gate.get('GeoPolygonPoints');
      this.MapTargetMode = "polygon";
      this.RefreshGateBackgroundItems(gate, gate);
    }
  }
  public SetMapTargetControllerDevice(device: any, lane: any, gate: any) {
    this.SetMapTargetController(lane, gate);
    this.HighlightTarget = device;
  }
  public SetMapTargetController(lane: any, gate: any) {
    this.GateBackgroundPolygons = [lane, gate];
    if (lane.get('LocalControllerId')?.value != null) {
      let controller = this.GetController(lane.get('LocalControllerId')?.value);
      if (controller != null) {
        this.MapTarget = controller.get('LocationPoints');
        this.MapTargetMode = "marker";
        this.HighlightTarget = controller.get('Id')?.value;
      }
      this.RefreshGateBackgroundItems(gate, controller);
    }

  }
  public RefreshAreaBackgroundItems() {
    this.AreaBackgroundPolygons = [];
    this.AreaBackgroundMarkers = [];
    for (let p of this.FormArray(this.Form, "ParkingLots").controls) {
      this.AreaBackgroundPolygons.push(p);
      this.AreaBackgroundMarkers.push(p);
    }
    for (let g of this.FormArray(this.Form, "Gates").controls) {
      this.AreaBackgroundPolygons.push(g);
      for (let l of this.FormArray(g, "Lanes").controls) {
        this.AreaBackgroundPolygons.push(l);
      }
    }
  }
  public RefreshGateBackgroundItems(gate: any, exclude: any) {
    this.GateBackgroundPolygons = [];
    this.GateBackgroundMarkers = [];
    if (gate != exclude) {
      this.GateBackgroundPolygons.push(gate);
      this.GateBackgroundMarkers.push(gate);
    }
    for (let lane of this.FormArray(gate, "Lanes").controls) {
      if (lane != exclude) {
        this.GateBackgroundPolygons.push(lane);
        this.GateBackgroundMarkers.push(lane);
      }
      for (let camera of this.FormArray(lane, "Cameras").controls) {
        if (camera != exclude) {
          this.GateBackgroundPolygons.push(camera);
          this.GateBackgroundMarkers.push(camera);
        }
      }
      for (let barrier of this.FormArray(lane, "Barriers").controls) {
        if (barrier != exclude) {
          this.GateBackgroundPolygons.push(barrier);
          this.GateBackgroundMarkers.push(barrier);
        }
      }
      if (lane.get("LocalControllerId")?.value != null) {
        let controller = this.GetController(lane.get("LocalControllerId")?.value);
        if (controller != null && controller != exclude) {
          this.GateBackgroundPolygons.push(controller);
          this.GateBackgroundMarkers.push(controller);
        }
      }
    }
  }
  public MapMarkerClicked(formControl: UntypedFormControl) {
    let className = formControl.get('ClassName')?.value;
    switch (className) {
      case "Gate":
        this.SetMapTarget(null, null, formControl);
        break;
      case "Lane":
        this.SetMapTarget(null, formControl, formControl.parent?.parent);
        break;
      case "LocalController":
        //find the first lane that uses this controller
        let controllerId = formControl.get('Id')?.value;
        for (let g of this.FormArray(this.Form, 'Gates').controls) {
          for (let l of this.FormArray(g, 'Lanes').controls) {
            if (l.get('LocalControllerId')?.value == controllerId) {
              this.SetMapTargetController(l, g);
              break;
            }
          }
        }
        break;
      default:
        this.SetMapTarget(formControl, formControl.parent?.parent, formControl.parent?.parent?.parent?.parent);

    }

  }

  public AddUserInputDevice(lane: any) {
    let p = { Id: uuidv4(), ActiveDirection: "Both", Name: "Multi Scanner", Type: "MultiInputScanner", ClassName: "UserInput", DeviceStatus: "New", ComPort: "COM1", SerialNumber: "" };
    this.EditUserInputDevice(this.AddToFormArray(lane.get('UserInputDevices') as UntypedFormArray, p, "Gates.Lanes.UserInputDevices"))
  }
  public EditUserInputDevice(device: any) {
    this.modalService.addModal(EditcontrolledareauserinputComponent, { Form: device })
      .subscribe((result) => {
        if (result != null) {
        }
      });
  }
  
  public RemoveUserInputDevice(lane: AbstractControl, index: number) {
    this.RemoveFromFormArray(lane.get('UserInputDevices') as UntypedFormArray, index);
  }

  IsLinkAdjustable(sourceLot: AbstractControl, targetLot: AbstractControl): boolean {
    const link = this.GetLink(sourceLot as FormGroup, targetLot as FormGroup);
    return link?.get('IsAllocationAdjustable')?.value === true;
  }

  OpenSpaceAllocationModal(parkinglot1Id: string, parkinglot2Id: string) {
    const link = this.FormArray(this.Form, "ParkingLotLinks").controls.find(link => 
      (link.get('SourceParkingLotId')?.value === parkinglot1Id && link.get('TargetParkingLotId')?.value === parkinglot2Id) ||
      (link.get('SourceParkingLotId')?.value === parkinglot2Id && link.get('TargetParkingLotId')?.value === parkinglot1Id)
    );
    
    if(link == null || !link.get('IsAllocationAdjustable')?.value) {
      return;
    }

    const parkingLot1 = this.GetParkingLotById(parkinglot1Id);
    const parkingLot2 = this.GetParkingLotById(parkinglot2Id);

    if (!parkingLot1 || !parkingLot2) {
      return;
    }

    const parkingLots = [
      {
        name: parkingLot1.get('Name')?.value,
        totalSpaces: parkingLot1.get('TotalSpaces')?.value
      },
      {
        name: parkingLot2.get('Name')?.value,
        totalSpaces: parkingLot2.get('TotalSpaces')?.value
      }
    ];

    this.modalService.addModal(SpaceAllocationModalComponent, { parkingLots: parkingLots })
      .subscribe((result: { name: string; totalSpaces: number }[] | null) => {
        if (result != null) {
          // Update the parking lot spaces with the new allocations
          parkingLot1.get('TotalSpaces')?.setValue(result[0].totalSpaces);
          parkingLot2.get('TotalSpaces')?.setValue(result[1].totalSpaces);

          // Update the parking lot link's allocated spaces
          if (link.get('SourceParkingLotId')?.value === parkinglot1Id) {
            link.get('SourceAllocatedSpaces')?.setValue(result[0].totalSpaces);
            link.get('TargetAllocatedSpaces')?.setValue(result[1].totalSpaces);
          } else {
            link.get('SourceAllocatedSpaces')?.setValue(result[1].totalSpaces);
            link.get('TargetAllocatedSpaces')?.setValue(result[0].totalSpaces);
          }
        }
      });
  }

  private ProcessParkingLotLinks() {
    const parkingLots = this.FormArray(this.Form, 'ParkingLots').controls;
    const links = new Map<string, any[]>();

    // First, collect all links from each parking lot
    parkingLots.forEach(lot => {
      const lotId = lot.get('Id')?.value;
      if (!lotId) return;

      const lotLinks = lot.get('Links')?.value || [];
      if (!links.has(lotId)) {
        links.set(lotId, []);
      }
      const lotLinksArray = links.get(lotId);
      if (lotLinksArray) {
        lotLinksArray.push(...lotLinks);
      }
    });

    // Now create a form array for the links if it doesn't exist
    if (!this.Form.get('ParkingLotLinks')) {
      this.Form.addControl('ParkingLotLinks', new UntypedFormArray([]));
    }

    // Clear existing links
    const linksArray = this.FormArray(this.Form, 'ParkingLotLinks');
    while (linksArray.length > 0) {
      linksArray.removeAt(0);
    }

    // Add new links
    links.forEach((lotLinks, lotId) => {
      lotLinks.forEach(link => {
        const targetLotId = link.ParkingLotId;
        // Only add the link if both parking lots are in this controlled area
        if (parkingLots.some(lot => lot.get('Id')?.value === targetLotId)) {
          const linkForm = new UntypedFormGroup({
            SourceParkingLotId: new UntypedFormControl(lotId),
            TargetParkingLotId: new UntypedFormControl(targetLotId),
            IsAllocationAdjustable: new UntypedFormControl(link.IsAllocationAdjustable),
            Direction: new UntypedFormControl(link.Direction)
          });
          linksArray.push(linkForm);
        }
      });
    });
  }
}
